import * as CookieConsent from "vanilla-cookieconsent";
import store from "@/store";


var user_consent_submit = false;


const gtag = function () {
    dataLayer.push(arguments);
}


export const setCookieConsentFromCookie = function () {

    let cookieContentsCookie = CookieConsent.getCookie();
    let consent = {
        functionality: false,
        analytics: false,
        advertisement: false,
        preferences: false,
    };

    if (cookieContentsCookie.categories.includes("functionality")) {
        consent.functionality = true;
    }
    if (cookieContentsCookie.categories.includes("analytics")) {
        consent.analytics = true;
    }
    if (cookieContentsCookie.categories.includes("advertisement")) {
        consent.advertisement = true;
    }
    if (cookieContentsCookie.categories.includes("preferences")) {
        consent.preferences = true;
    }

    setCookieConsent(false, consent);
}
export const setCookieConsent = function (update, consent = null) {

    if (consent === null) {
        consent = {
            functionality: false,
            analytics: false,
            advertisement: false,
            preferences: false,
        };
        consent.necessary = true;
        if (CookieConsent.acceptedCategory('functionality')) {
            consent.functionality = true;
        }

        if (CookieConsent.acceptedCategory('analytics')) {
            consent.analytics = true;
        }

        if (CookieConsent.acceptedCategory('advertisement')) {
            consent.advertisement = true;
        }

        if (CookieConsent.acceptedCategory('preferences')) {
            consent.preferences = true;
        }
    }


    // Map with cookie consent banner and google consent mode variables from tag manager.
    const consentMode = {
        'functionality_storage': consent.functionality ? 'granted' : 'denied',
        'security_storage': consent.necessary ? 'granted' : 'denied',
        'ad_storage': consent.advertisement ? 'granted' : 'denied',
        'analytics_storage': consent.analytics ? 'granted' : 'denied',
        'ad_user_data': consent.advertisement ? 'granted' : 'denied',
        'ad_personalization': consent.analytics ? 'granted' : 'denied',
        'analytics': consent.analytics ? 'granted' : 'denied',
        'personalization': consent.preferences ? 'granted' : 'denied',
    };


    if (consent.advertisement === true) {
        store.dispatch('UserConsent/consentAdvertisement', true)
    }

    if (consent.analytics === true) {
        store.dispatch('UserConsent/consentAnalytics', true)
        gtag('consent', 'update', consentMode);
        if (update) {
            dataLayer.push({
                'event': 'consent_banner_update',
                'user_consent': consentMode
            });
        }
    }

}

// let languageSet = computed(() => store.getters.languageSet);


export const cookieConsentConfig = {

    // Categories for Cookie consent Banner
    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        functionality: {},
        analytics: {}, // this category is for google analytics
        advertisement: {}, // this category is for google ads
        preferences: {}, // this category is for personal preferences
    },

    language: {
        default: 'en', translations: {
            en: {
                consentModal: {
                    title: 'Your privacy',
                    description: 'We use cookies to improve your experience on our site and to show you relevant advertising.',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    showPreferencesBtn: 'Manage Individual preferences'
                }, preferencesModal: {
                    title: 'Manage cookie preferences',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Accept current selection',
                    closeIconLabel: 'Close modal',
                    sections: [{
                        title: 'Our use of cookies',
                        description: 'For more information, please see our <a href="/online-testing/privacy/">privacy policy</a> which contains details about your ' + 'rights regarding your personal data.<br/><br/>' + 'For more detailed information about the cookies we use, see our <a href="/online-testing/cookie-disclosure/">Cookies page</a>.'
                    }, {
                        title: 'Necessary cookies',
                        description: 'Necessary cookies enable core functionality such as security, network management, ' + 'and accessibility. You may disable these by changing your browser settings, but this ' + 'may affect how the website functions.',

                        //this field will generate a toggle linked to the 'necessary' category
                        linkedCategory: 'necessary'
                    }, {
                        title: 'Functionality',
                        description: 'These trackers enable basic interactions and functionalities that allow you to access selected features of our service and facilitate your communication with us.',
                        linkedCategory: 'functionality'
                    }, {
                        title: 'Experience',
                        description: 'These trackers help us to improve the quality of your user experience and enable interactions with external content, networks and platforms.',
                        linkedCategory: 'preferences'
                    }, {
                        title: 'Measurement',
                        description: 'These trackers help us to measure traffic and analyses your behaviour to improve our service.',
                        linkedCategory: 'analytics'
                    }, {
                        title: 'Marketing',
                        description: 'These trackers help us to deliver personalized ads or marketing content to you, and to measure their performance.',
                        linkedCategory: 'advertisement'
                    }, {
                        title: 'More information',
                        description: 'For any queries in relation to my policy on cookies and your choices, please <a href="/online-testing/contact-us/">contact us</a>'
                    }]
                }
            }
        }
    },
    cookie: {
        expiresAfterDays: acceptType => {
            return 365;
        }
    },
    onConsent: ({cookie}) => {
        window.dataLayer = window.dataLayer || [];

        // When onFirstConsent triggered, then onConsent is triggered at the same time
        if (user_consent_submit === false) {
            setCookieConsent(false);
        } else {
            user_consent_submit = false;
        }
    },
    /**
     * Very first consent change by user. We don't have show consent banner button
     * Which guarantee this call back called only once after user select
     * @param cookie
     */
    onFirstConsent: ({cookie}) => {

        setCookieConsent(true);
        user_consent_submit = true;
    },
    onModalReady: ({modalName, modal}) => {

        // get cookie contents
        let cookieContents = CookieConsent.getCookie()

        // check if cookie has set up before, if not initialise the cookie and google consent data
        if ((cookieContents.hasOwnProperty('categories')) === false) {

            window.dataLayer = window.dataLayer || [];
            let consent = {
                necessary: true,
                functionality: false,
                advertisement: false,
                analytics: false,
                preferences: false
            };
            setCookieConsent(consent, false);
        } else {

            CookieConsent.hide();
        }
    }
}
